import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';

export const StyledCenteredBox = styled(Box)`
  text-align: center;
`;

StyledCenteredBox.displayName = 'StyledCenteredBox';
